import { useNavigate } from 'react-router-dom';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import GroupsIcon from '@mui/icons-material/Groups';
import NotificationsIcon from '@mui/icons-material/Notifications';
import UserIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
// import TimelineIcon from '@mui/icons-material/Timeline';
import WorkIcon from '@mui/icons-material/Work';

import { NotificationType } from 'services/busmanApi/types';

export const ABN = 'ABN 21 143 786 216';

export const USER_ROLES = {
  ADMIN: 'A',
  MANAGER: 'M',
  EMPLOYEE: 'E',
};

// Ordinals from the backend EmploymentTypes/EmploymentCategory enums. The API itself stores and
// validates the member *name* (e.g. 'FullTime'), so only use these for consumers that want the
// numeric form -- convert at the boundary, never in the form state.
export const EMPLOYMENT_TYPE_ORDINAL: Record<string, number> = {
  FullTime: 0,
  Casual: 1,
  PartTime: 2,
};

export const EMPLOYMENT_CATEGORY_ORDINAL: Record<string, number> = {
  Permanent: 0,
  Temporary: 1,
};

export const WORKLOG_TYPE = {
  WORKLOG: 'worklog',
  LEAVELOG: 'leavelog',
};

export const DESCRIPTION_LIMIT = 255;

export const WORKLOGS_LIMIT = 400;

export const COMPANY_ID = 'd1eed91e-f656-472b-a3cb-7643ba169395';

export const COMPANY_DETAILS = {
  company_name: 'Element Engineering Australia',
  company_address: '5 Carson Rd, Malaga WA 6090',
  company_phone: '+61 8 6262 1111',
  company_email: 'info@elementengineering.com.au',
  company_website: 'https://www.elementengineering.com.au/',
  company_abn: '21 143 786 216',
};

export const TERMS_AND_CONDITIONS =
  'This quote outlines the maximum cost using information supplied at the time of quotation. Any change in the scope will result in a variation or will be time billed in addition to the quoted amount whereby the client will be informed prior. If design objectives cannot be achieved in accordance with relevant standards, the client will be notified and all hours utilised up to this point of discovery will be billed to the client. This quote is subject to Element Engineering Australias terms and conditions available upon request';

export const APP_BAR_TOP_ICONS = [
  { label: 'ME', Icon: UserIcon, permission: 'All', drawer: true },
  { label: 'TEAMS', Icon: GroupsIcon, permission: ['A', 'M'], drawer: true },
];

export const APP_BAR_BOTTOM_ICONS = [
  // { label: 'PROJECT', Icon: TimelineIcon, permission: ['A', 'M'], drawer: false },
  { label: 'CLIENT', Icon: WorkIcon, permission: ['A', 'M'], drawer: true },
  { label: 'SETTING', Icon: SettingsIcon, permission: ['A'], drawer: true },
  { label: 'NOTIFICATIONS', Icon: NotificationsIcon, permission: 'All', drawer: false },
  { label: 'ACCOUNT', Icon: AccountCircleIcon, permission: 'All', drawer: true },
];

export const createNotificationOnClickMap = (navigate: ReturnType<typeof useNavigate>) => ({
  W: (notification: NotificationType) => navigate(`/worklogs/${notification.related_type_id}`),
  J: (notification: NotificationType) => navigate(`/jobs/${notification.related_type_id}`),
});

export const NOTIFICATION_ICON_MAP = {
  W: ForumOutlinedIcon,
  J: ForumOutlinedIcon,
  // ...add more types as needed
};

export const JOB_TYPE_LABELS: string[] = ['Quoted', 'Time Billed', 'Internal'];

export type StatusProps = {
  name: string;
  value: string;
};

export const PROJECT_STATUS: Record<string, StatusProps> = {
  all: { name: 'All', value: 'All' },
  pending: { name: 'Pending', value: 'PENDING' },
  approved: { name: 'Approved', value: 'APPROVED' },
  inProgress: { name: 'In Progress', value: 'IN_PROGRESS' },
  completed: { name: 'Completed', value: 'COMPLETED' },
  rejected: { name: 'Rejected', value: 'REJECTED' },
  onHold: { name: 'On Hold', value: 'ON_HOLD' },
  archived: { name: 'Archived', value: 'ARCHIVED' },
};

export const PROJECT_SCOPE_STATUS: Record<string, StatusProps> = {
  draft: { name: 'Draft', value: 'DRAFT' },
  pending: { name: 'Pending Approval', value: 'PENDING_APPROVAL' },
  approved: { name: 'Approved', value: 'APPROVED' },
  superseded: { name: 'Superseded', value: 'SUPERSEDED' },
  rejected: { name: 'Rejected', value: 'REJECTED' },
};

export const JOB_PRIORITY = {
  LOW: 'Low',
  HIGH: 'High',
  MEDIUM: 'Medium',
};

export const JOB_TYPE = {
  TIMEBILLED: 'TimeBilled',
  INTERNAL: 'Internal',
  // QUOTED: 'Quoted',
};

export const TASK_STATUS: Record<string, StatusProps> = {
  PENDING: { value: 'Pending', name: 'Pending' },
  INPROGRESS: { value: 'InProgress', name: 'In Progress' },
  COMPLETED: { value: 'Completed', name: 'Completed' },
  CANCELLED: { value: 'Cancelled', name: 'Cancelled' },
  ONHOLD: { value: 'OnHold', name: 'On Hold' },
};

export const MYOB_TAX_TYPE: Record<string, StatusProps> = {
  IMPORT_DUTY: {
    value: 'IMPORT_DUTY',
    name: 'Import Duty',
  },
  SALES_TAX: {
    value: 'SALES_TAX',
    name: 'Sales Tax',
  },
  GST_VAT: {
    value: 'GST_VAT',
    name: 'Goods and Services Tax',
  },
  INPUT_TAXED: {
    value: 'INPUT_TAXED',
    name: 'Input Taxed',
  },
  LUXURY_CAR_TAX: {
    value: 'LUXURY_CAR_TAX',
    name: 'Luxury Car Tax',
  },
  WITHHOLDINGS_TAX: {
    value: 'WITHHOLDINGS_TAX',
    name: 'Withholdings Tax',
  },
  NOABN_TFN: {
    value: 'NOABN_TFN',
    name: 'No ABN TFN',
  },
  // Leave out for the moment
  // CONSOLIDATED: {
  //   value: 'CONSOLIDATED',
  //   name: 'Consolidated',
  // },
};
